<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">CONTENTS</p>
<p class="toc"><a href="#/foreword#f1">Foreword, by John Karras, co-founder of RAGBRAI</a></p>
<p class="toc"><a href="#/preface">Preface: It’s Not <i>Just</i> About the Bike</a></p>
<p class="toc"><a href="#/acknowledgement">Acknowledgements</a></p>
<p class="toc"><a href="#/introduction">Introduction: Why It Works</a></p>
<p class="toc1"><a href="#/chapter01">1. Karras and Kaul’s Caper: The First Year</a></p>
<p class="toc"><span href="#/chapter02" title="Link target outside of Sample">2. Still Crazy After Forty Years: RAGBRAI’s Best Stories</span></p>
<p class="toc"><span href="#/chapter03" title="Link target outside of Sample">3. What It’s All About: An Overview</span></p>
<p class="toc"><span href="#/chapter04" title="Link target outside of Sample">4. RAGBRAI Catches On, Grows: The Benson Years</span></p>
<p class="toc"><span href="#/chapter05" title="Link target outside of Sample">5. Further Development: The Green Years</span></p>
<p class="toc"><span href="#/chapter06" title="Link target outside of Sample">6. A Family Affair: The Juskiewicz Years</span></p>
<p class="toc"><span href="#/chapter07" title="Link target outside of Sample">7. Teams: The Good, the Bad, the Ugly</span></p>
<p class="toc"><span href="#/chapter08" title="Link target outside of Sample">8. Nuts and Bolts: How It Works</span></p>
<p class="toc"><span href="#/chapter09" title="Link target outside of Sample">9. Shift Happens: When Things Go Wrong</span></p>
<p class="toc"><span href="#/chapter10" title="Link target outside of Sample">10. RAGBRAI Inspires…Romance, Art, Other Rides, Etc</span>.</p>
<p class="toc"><span href="#/chapter11" title="Link target outside of Sample">11. Iowa and RAGBRAI: A Good Fit</span></p>
<p class="toc1"><span href="#/afterword" title="Link target outside of Sample">Afterword: A Magic Wand</span></p>
<p class="toc"><span href="#/author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?a48e5e3c